// import { configureStore } from '@reduxjs/toolkit';
import globalReducer from './global/reducer';
import createSagaMiddleware from 'redux-saga';
import 'regenerator-runtime/runtime';
import userReducer, { watchUser } from './user/reducer';
import applicationReducer, { watchApplication } from './application/reducer';
import dialogReducer from './dialog/reducer';
import postApprovalReducer, { watchPostApprovalDocument } from './postApproval/reducer';
import SystemReducer, { watchSystem } from './system/reducer';
import columnReducer from './column/columnReducer';
import landingReducer, { watchLanding } from './landing/reducer';
import applicationDetailReducer, { watchApplicationDetail } from './applicationDetail/reducer';
import SystemMessageReducer from './system/systemMessageReducer';
import tableReducer from './table/reducer';
import notificationReducer, { watchNotification } from './notification/reducer';
import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import { all } from 'redux-saga/effects';
import applicationDetailPostDataReducer, {
    watchApplicationDetailPostData,
} from './applicationDetail/applicationDetailPostDataReducer';
import userAccountReducer, { watchUserAccount } from './userAccount/reducer';
import emailDomainReducer, { watchEmailDomain } from './emailDomain/reducer';
import globalVariablesReducer, { watchGlobalVariables } from './globalVariables/reducer';
import broadcastMessageReducer, { watchBroadcastMessage } from './broadcastMessage/reducer';
import emailTemplateReducer, { watchEditEmailTemplate } from './emailTemplate/reducer';
import menuReducer, { watchMenu } from './menu/reducer';
import applicationDetailValidReducer, {
    watchApplicationDetailValid,
} from './applicationDetail/applicationDetailValidReducer';
import searchReducer, { watchSearch } from './search/reducer';
import validationReducer from './validation/reducer';
import clinicalStudyCategorizationReducer, {
    watchClinicalStudyCategorization,
} from './applicationDetail/clinicalStudyCategorizationReducer';
import documentUploadReducer, { watchDocumentUpload } from './applicationDetail/documentUploadReducer';
import textLengthReducer from './textLength/reducer';
import declarationAndEndorsementReducer, {
    watchDeclarationAndEndorsement,
} from './applicationDetail/declarationAndEndorsementReducer';
import reviewerReducer, { watchReviewer } from './reviewer/reducer';
import reviewPanelReducer, { watchReviewPanel } from './reviewPanel/reducer';
import arrangeMeetingReducer, { watchArrangeMeeting } from './arrangeMeeting/reducer';
import confirmResultReducer, { watchConfirmResult } from './confirmResult/reducer';
import consolidationDetailReducer, { watchConsolidationDetail } from './consolidation/reducer';
import susarReportReducer, { watchSusarReport } from './susarReport/reducer';
import miscellaneousReportReducer, { watchMiscellaneousReport } from './miscellaneousReport/reducer';
import progressReportReducer, { watchProgressReport } from './progressReport/reducer';
import protocolDeviationReportReducer, { watchProtocolDeviationReport } from './protocolDeviationReport/reducer';
import localSAEReportReducer, { watchLocalSAEReport } from './localSAEReport/reducer';
import finalReducer, { watchFinalReport } from './finalReport/reducer';
import commentReducer, { watchComment } from './comment/reducer';

const rootReducer = combineReducers({
    column: columnReducer,
    global: globalReducer,
    user: userReducer,
    application: applicationReducer,
    dialog: dialogReducer,
    postApproval: postApprovalReducer,
    system: SystemReducer,
    systemMessage: SystemMessageReducer,
    notification: notificationReducer,
    landing: landingReducer,
    applicationDetail: applicationDetailReducer,
    applicationDetailPostData: applicationDetailPostDataReducer,
    userAccount: userAccountReducer,
    emailDomain: emailDomainReducer,
    globalVariables: globalVariablesReducer,
    broadcastMessage: broadcastMessageReducer,
    emailTemplate: emailTemplateReducer,
    applicationDetailValid: applicationDetailValidReducer,
    menu: menuReducer,
    search: searchReducer,
    validation: validationReducer,
    table: tableReducer,
    clinicalStudyCategorization: clinicalStudyCategorizationReducer,
    documentUpload: documentUploadReducer,
    declarationAndEndorsement: declarationAndEndorsementReducer,
    textLength: textLengthReducer,
    reviewer: reviewerReducer,
    reviewPanel: reviewPanelReducer,
    arrangeMeeting: arrangeMeetingReducer,
    confirmResult: confirmResultReducer,
    consolidationDetail: consolidationDetailReducer,
    susarReport: susarReportReducer,
    miscellaneousReport: miscellaneousReportReducer,
    progressReport: progressReportReducer,
    protocolDeviationReport: protocolDeviationReportReducer,
    localSAEReport: localSAEReportReducer,
    finalReport: finalReducer,
    comment: commentReducer,
});

function* rootSaga() {
    yield all([
        watchApplication(),
        watchUser(),
        watchPostApprovalDocument(),
        watchSystem(),
        watchLanding(),
        watchApplicationDetail(),
        watchApplicationDetailPostData(),
        watchUserAccount(),
        watchEmailDomain(),
        watchGlobalVariables(),
        watchBroadcastMessage(),
        watchEditEmailTemplate(),
        watchApplicationDetailValid(),
        watchMenu(),
        watchNotification(),
        watchSearch(),
        watchClinicalStudyCategorization(),
        watchDocumentUpload(),
        watchDeclarationAndEndorsement(),
        watchReviewer(),
        watchReviewPanel(),
        watchArrangeMeeting(),
        watchConfirmResult(),
        watchConsolidationDetail(),
        watchSusarReport(),
        watchMiscellaneousReport(),
        watchProgressReport(),
        watchProtocolDeviationReport(),
        watchLocalSAEReport(),
        watchFinalReport(),
        watchComment(),
    ]);
}

const sagaMiddleware = createSagaMiddleware({
    onError: (err) => {
        console.log('161843 index.js err', err);
    },
});

const middleware = [sagaMiddleware];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middleware)));

export default store;

export const getStore = () => {
    return store;
};

export const safeSaga = (func) => {
    return function* (args) {
        try {
            yield* func(args);
        } catch (error) {
            console.log('162112 index.js error', error);
            // yield put(setSagaError({ saga: func.name, args, error }));
        }
    };
};

sagaMiddleware.run(rootSaga);
